:host {
  display: block;
  box-sizing: border-box;
  --document-listing-top-margin: 0;
  --document-listing-top-margin-mobile: 0;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .heading {
    font-size: 1rem;
    line-height: 1.5625rem;
  }
}

@media screen and (min-width: 980px) {
  .heading {
    font-size: 1.75rem;
    line-height: 1.875rem;
  }
}

.product-documents {
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.product-documents--shown {
  height: auto;
  display: block;
  visibility: visible;
}

.product-documents--shown + .product-documents--shown {
  margin-top: 20px;
}

@media screen and (min-width: 980px) {
  .product-documents--shown + .product-documents--shown {
    margin-top: 8px;
  }
}

.product-documents--shown .document-listing-container {
  background: transparent;
}

.content,
.heading {
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
}

.content *,
.content *::before,
.content *::after,
.heading *,
.heading *::before,
.heading *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .content,
.heading {
    padding: 0 10px;
  }
}

@media screen and (min-width: 980px) {
  .heading {
    margin-top: 43px;
  }
}

@media screen and (max-width: 979px) {
  pes-document-listing .pes-document-listing {
    margin-left: -16px;
    margin-right: -16px;
  }
}